import axios, { AxiosResponse } from 'axios';
import { getHostname } from '../utils';

export const postFeature = async (
  projectId: string,
  featureId: string,
  featureName: string,
  defaultContent?: string
) => {
  await axios.post('/api/clientevent/feature', {
    projectId,
    featureId,
    featureName,
    hostName: getHostname(),
    defaultContent,
  });
};

export const postException = async (response: AxiosResponse | undefined) => {
  if (response?.request) {
    await axios.post('/api/clientevent/exception', {
      url: response.request.responseURL,
      status: response.status,
      statusDetails: response.statusText,
    });
  }
};
